import { asText } from "./coerce";

export const formatDurationLabel = (value: unknown) => {
  const text =
    typeof value === "number" && Number.isFinite(value)
      ? String(value)
      : asText(value);

  if (!text) return undefined;

  if (!/^\d+(?:[.,]\d+)?$/.test(text)) return text;

  const totalMinutes = Number(text.replace(",", "."));
  if (!Number.isFinite(totalMinutes) || totalMinutes <= 0) return undefined;

  const roundedMinutes = Math.round(totalMinutes);
  const hours = Math.floor(roundedMinutes / 60);
  const minutes = roundedMinutes % 60;

  if (!hours) return `${minutes} min`;
  return minutes ? `${hours}h ${minutes}m` : `${hours}h`;
};

export const firstDurationLabel = (...values: unknown[]) => {
  for (const value of values) {
    const duration = formatDurationLabel(value);
    if (duration) return duration;
  }

  return undefined;
};
